<template>
  <div>
    <i class="bx" :class="showRoom ? 'bxs-minus-square' : 'bxs-plus-square'" @click="showRoom = !showRoom" />
    <span @dblclick="onSwitchRoom(room.name)" @contextmenu.prevent.stop="emit('openRoomMenu', room.name, $event)">
      {{ room.displayName }}
    </span>
    <b v-if="room.sortedUsers.length > 0">({{ room.sortedUsers.length }})</b>
    <i v-if="room.name !== MAIN_ROOM" class="bx bx-x" @click="closeRoom(room)" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Room } from '../models/Room';
import { MAIN_ROOM } from '../types';
import { getApp } from '../models/App';
import { User } from '../models/User';

const props = defineProps<{ name: string }>();
const emit = defineEmits<{
  (e: 'openRoomMenu', roomName: string, event: MouseEvent): void;
}>();

const showRoom = defineModel('showRoom', {
  type: Boolean,
  required: true,
});

const app = getApp();
const room = computed(() => Room.get(props.name) as Room);

const closeRoom = (room: Room) => {
  getApp().restrictedSend(`[breakout]close:${room.name}`);
};

const onSwitchRoom = (name: string) => {
  const user = User.get(app.connection.id);
  if (user && (user.permissions.rooms || user.role === 'teacher')) {
    app.send(`[switch]${app.connection.id}:${name}`);
  }
};

defineExpose({ showRoom });
</script>

<style scoped>
div {
  font-size: 14px;
  display: flex;
  align-items: center;
}

div > span {
  font-weight: bold;
  margin-left: 9px;
  flex-grow: 1;
}

div > i {
  cursor: pointer;
}
</style>
